<template>
  <div class="min-h-screen bg-slate-900 flex items-center justify-center px-4">

    <!-- Tarjeta de login -->
    <div class="w-full max-w-md">

      <!-- Logo -->
      <div class="flex flex-col items-center mb-8">
        <div class="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-400 to-green-600 flex items-center justify-center shadow-xl shadow-emerald-500/40 mb-4">
          <i class="fa-solid fa-laptop-code text-white text-2xl"></i>
        </div>
        <h1 class="text-white font-black text-2xl tracking-tight">
          MADAV<span class="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-green-400">Solutions</span>
        </h1>
        <p class="text-slate-400 text-sm mt-1">Inicia sesión para continuar</p>
      </div>

      <!-- Formulario -->
      <div class="bg-slate-800 rounded-2xl border border-white/10 shadow-2xl p-8">
        <form @submit.prevent="iniciarSesion">

          <!-- Email -->
          <div class="mb-5">
            <label class="block text-slate-300 text-sm font-medium mb-2">
              <i class="fa-solid fa-envelope mr-2 text-emerald-400"></i>Correo electrónico
            </label>
            <input
              v-model="email"
              type="email"
              autocomplete="username"
              placeholder="correo@ejemplo.com"
              class="w-full bg-slate-700 border border-white/10 text-white rounded-xl px-4 py-3 text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 transition"
            />
          </div>

          <!-- Contraseña -->
          <div class="mb-6">
            <label class="block text-slate-300 text-sm font-medium mb-2">
              <i class="fa-solid fa-lock mr-2 text-emerald-400"></i>Contraseña
            </label>
            <div class="relative">
              <input
                v-model="password"
                :type="mostrarPassword ? 'text' : 'password'"
                autocomplete="current-password"
                placeholder="••••••••"
                class="w-full bg-slate-700 border border-white/10 text-white rounded-xl px-4 py-3 pr-12 text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 transition"
              />
              <button
                type="button"
                @click="mostrarPassword = !mostrarPassword"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white transition"
                tabindex="-1"
              >
                <i :class="mostrarPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
              </button>
            </div>
          </div>

          <!-- Error -->
          <div v-if="errorMsg" class="mb-4 bg-red-500/10 border border-red-500/30 text-red-400 text-sm rounded-xl px-4 py-3">
            <i class="fa-solid fa-circle-exclamation mr-2"></i>{{ errorMsg }}
          </div>

          <!-- Botón -->
          <button
            type="submit"
            :disabled="cargando"
            class="w-full bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-400 hover:to-green-500 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold py-3 rounded-xl shadow-lg shadow-emerald-500/30 transition-all duration-200 hover:scale-[1.02]"
          >
            <span v-if="cargando">
              <i class="fa-solid fa-spinner fa-spin mr-2"></i>Ingresando…
            </span>
            <span v-else>
              <i class="fa-solid fa-right-to-bracket mr-2"></i>Entrar
            </span>
          </button>

        </form>
      </div>

      <!-- Links de acceso -->
      <div class="text-center mt-4 space-y-2">
        <div>
          <router-link :to="{ name: 'OlvidePassword' }"
            class="text-emerald-500 hover:text-emerald-300 text-sm transition">
            ¿Olvidaste tu contraseña?
          </router-link>
        </div>
        <div>
          <router-link to="/" class="text-slate-500 hover:text-slate-300 text-sm transition">
            <i class="fa-solid fa-arrow-left mr-1"></i> Volver al inicio
          </router-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import authService from '@/services/auth.service'

export default {
  name: 'LoginView',
  data () {
    return {
      email:          '',
      password:       '',
      errorMsg:       '',
      cargando:       false,
      mostrarPassword: false
    }
  },
  methods: {
    async iniciarSesion () {
      this.errorMsg = ''

      if (!this.email.trim() || !this.password.trim()) {
        this.errorMsg = 'Por favor ingresa tu correo y contraseña.'
        return
      }

      this.cargando = true
      try {
        const { data } = await authService.login(this.email.trim(), this.password)

        if (!data.resultado) {
          this.errorMsg = data.mensaje || 'Credenciales incorrectas.'
          return
        }

        // Guardar sesión en localStorage
        localStorage.setItem('token',     data.token)
        localStorage.setItem('idUsuario', data.idUsuario)
        localStorage.setItem('nombre',    data.nombre)
        localStorage.setItem('email',     data.email)
        localStorage.setItem('idRol',     data.idRol)
        localStorage.setItem('nombreRol', data.nombreRol)

        // Redirigir según rol
        if (data.idRol === 1) {
          // Administrador → panel de administración
          this.$router.push({ name: 'AdminSistemas' })
        } else if (data.idRol === 2) {
          // Cliente → panel de selección de sistemas
          this.$router.push({ name: 'ClientePanel' })
        } else {
          // Rol inválido
          this.errorMsg = `Rol no válido: ${data.idRol}. Contacta al administrador.`
          console.error('Rol inválido:', data.idRol)
        }
      } catch (err) {
        this.errorMsg = 'Error al conectar con el servidor. Intenta de nuevo.'
        console.error(err)
      } finally {
        this.cargando = false
      }
    }
  }
}
</script>
